module.exports = __webpack_public_path__ + "static/media/Battery-0.61fbe824.svg";